// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('analysis.reports', {
        url: '/reports',
        templateUrl: 'main/analysis/reports/reports.tpl.html',
        controller: 'AnalysisReportsController as vm',
        resolve: {
            reports: reportsResolver,
            dataSources: dataSourcesResolver,
            userReports: userReportsResolver,
            sharedReports: sharedReportsResolver,
            localization: localizationResolver
        }
    });
}

// @ngInject
function reportsResolver(AnalysisApiService) {
    return AnalysisApiService.getReports();
}

// @ngInject
function dataSourcesResolver(AnalysisApiService) {
    return AnalysisApiService.getDataSources();
}

// @ngInject
function userReportsResolver(AnalysisApiService) {
    return AnalysisApiService.getUserReports();
}

// @ngInject
function sharedReportsResolver(AnalysisApiService) {
    return AnalysisApiService.getSharedReports();
}

// @ngInject
function localizationResolver(AnalysisApiService) {
    return AnalysisApiService.getLocalization();
}


// @ngInject
function AnalysisReportsController(AnalysisApiService, DS, reports, dataSources, $rootScope, $cookies, localization, loadSpinnerService,
                                  userReports, $location, $uibModal, $translate, $scope, sharedReports, ToasterService, ENV) {
    var vm = this;

    // properties
    vm.reports = reports;
    vm.dataSources = dataSources;
    vm.userReports = userReports;
    vm.editReportTemplates = false;
    vm.showUserReportList = false;
    vm.isLoadingReport = false;
    vm.selectedDataSource = {};
    vm.selectedReport = { id: -2, description: "", reportObject: "" };
    vm.selectedUserReport = { id: -1, description: "" };
    vm.selectedUserReport1 = { id: -1, description: "" };
    vm.userReportName = "";
    vm.reportComboBox = {};
    vm.initUserReports = true;
    vm.sharedReports = sharedReports;
    vm.selectedSharedReport = { id: -1, decription: "" };
    vm.showSharedReportList = false;
    vm.initSharedReports = true;
    vm.reportLevels = [];

    //functions
    vm.selectUserReports = selectUserReports;
    vm.loadReport = loadReport;
    vm.loadUserReport = loadUserReport;
    vm.saveReport = saveReport;
    vm.saveNewUserReport = saveNewUserReport;
    vm.canSaveUserReport = canSaveUserReport;
    vm.deleteUserReport = deleteUserReport;
    vm.loadUserReports = loadUserReports;
    vm.getUserReports = getUserReports;
    vm.editUserReport = editUserReport;
    vm.formatDate = formatDate;
    vm.comboBoxInitialized = comboBoxInitialized;
    vm.cancelEditUserReport = cancelEditUserReport;
    vm.editFormSelectedReportChanged = editFormSelectedReportChanged;
    vm.expandRows = expandRows;
    vm.collapseRows = collapseRows;
    vm.selectSharedReports = selectSharedReports;
    vm.selectedSharedReportChanged = selectedSharedReportChanged;
    vm.loadSharedReports = loadSharedReports;
    vm.cbSelectLevelChanged = cbSelectLevelChanged;
    vm.removeMeasures = removeMeasures;
    vm.convertAllReports = convertAllReports;

    var pivot = createPivot();

    var user = $rootScope.currentUser;
    vm.editReportTemplates = (user.username.substr(0, 4) === "thsv");

    if (!vm.editReportTemplates) {

        vm.reports.splice(0, 0, {
            id: -3,
            name: $translate.instant('reports.sharedReports')
        });

        vm.reports.splice(0, 0, {
            id: -2,
            name: $translate.instant('reports.myReports')
        });

        selectUserReports();
    }




    function selectUserReports() {
        vm.showUserReportList = true;
        vm.showSharedReportList = false;
        vm.selectedReport = _.find(vm.reports, { id: -2 });
        vm.loadUserReports();
    }

    function selectSharedReports() {
        vm.showSharedReportList = true;
        vm.showUserReportList = false;
        vm.selectedReport = _.find(vm.reports, { id: -3 });
        vm.loadSharedReports();
    }


    function loadUserReports() {
        AnalysisApiService.getUserReports().then(function (data) {
            vm.userReports = data;
            vm.userReports.splice(0, 0, {
                id: -1,
                name: '-'
            });
            console.log(vm.userReports);
            var report = _.find(vm.userReports, { id: vm.selectedUserReport.id });
            vm.selectedUserReport = report === undefined ? { id: -1, description: "" } : angular.copy(report);
            vm.initUserReports = false;

            if (vm.showUserReportList) {
                var cb = $scope.cbEditUserReport;

                cb._tbx.value = vm.selectedUserReport.name;

            }

        });
    }

    function loadSharedReports() {
        AnalysisApiService.getSharedReports().then(function (data) {
            vm.sharedReports = data;
            vm.sharedReports.splice(0, 0, {
                id: -1,
                name: '-'
            });
            console.log(vm.sharedReports);
            var report = _.find(vm.sharedReports, { id: vm.selectedSharedReport.id });
            vm.selectedSharedReport = report === undefined ? { id: -1, description: "" } : angular.copy(report);
            vm.initSharedReports = false;

            var cb = $scope.cbSharedReport;
            cb._tbx.value = vm.selectedSharedReport.name;

        });
    }

    function loadReport(reportId) {

        vm.showUserReportList = false;

        if (vm.isLoadingReport === true) {
            return;
        }


        var report = _.find(vm.reports, { id: reportId });
        vm.selectedReport = report;

        vm.isLoadingReport = true;

        vm.selectedDataSource = _.find(vm.dataSources, { id: report.dataSourceId });

        var dataUrl = DS.defaults.basePath + 'analysis/getCompressedCsvReportData/' + report.dataSourceId + '?token=' + $cookies.getObject('X-JetsoftToken');

        var reportText = report.reportObject;
        if (_.startsWith(report.reportObject, "<")) {
            /* jshint -W117 */
            reportText = fmCovertXmlReport(report.reportObject);
            /* jshint +W117 */
        }
        var jsonReport = JSON.parse(reportText);
        jsonReport.dataSource.filename = dataUrl;
        jsonReport.dataSource = assureDataSourceType(jsonReport.dataSource);
        jsonReport.localization = '';

        _.forEach(jsonReport.slice.measures, function (measure) {
            measure.availableAggregations = 'sum,count,distinctcount,average,product,min,max,percent,percentofcolumn,percentofrow,index';
        });

        try {
            pivot.setReport(jsonReport);
            pivot.closeFieldsList();
        }
        catch (error) {
            vm.isLoadingReport = false;
            pivot.clear();
            pivot.refresh();
            ToasterService.showError('"' + report.name + '": ' + error.message, 'error', "Rapporter");
        }

        $scope.cbSaveUserReport._tbx.value = report.name;

    }

    function loadUserReport(reportId) {
        if (vm.isLoadingReport === true || reportId === -1) {
            return false;
        }
        vm.isLoadingReport = true;

        var report = _.find(vm.userReports, { id: reportId });

        try {

            vm.selectedUserReport = report === undefined ? { id: -1, description: "" } : angular.copy(report);


            var dataUrl = DS.defaults.basePath + 'analysis/getCompressedCsvReportData/' + vm.selectedUserReport.dataSourceId + '?token=' + $cookies.getObject('X-JetsoftToken');

            var reportText = vm.selectedUserReport.reportObject;
            if (_.startsWith(vm.selectedUserReport.reportObject, "<")) {
                /* jshint -W117 */
                reportText = fmCovertXmlReport(vm.selectedUserReport.reportObject);
                /* jshint +W117 */
            }
            var jsonReport = JSON.parse(reportText);
            jsonReport.dataSource.filename = dataUrl;
            jsonReport.dataSource = assureDataSourceType(jsonReport.dataSource);
            jsonReport.localization = '';

            pivot.setReport(jsonReport);
            pivot.closeFieldsList();

        } catch (error) {
            vm.isLoadingReport = false;
            pivot.clear();
            pivot.refresh();
            ToasterService.showError('"' + report.name + '": ' + error.message, 'error', "Rapporter");
        }
    }

    function loadSharedReport(reportId) {
        if (vm.isLoadingReport === true || reportId === -1) {
            return false;
        }
        vm.isLoadingReport = true;

        var report = _.find(vm.sharedReports, { id: reportId });

        try {

            vm.selectedSharedReport = report === undefined ? { id: -1, description: "" } : angular.copy(report);


            var dataUrl = DS.defaults.basePath + 'analysis/getCompressedCsvReportData/' + vm.selectedSharedReport.dataSourceId + '?token=' + $cookies.getObject('X-JetsoftToken');

            var reportText = vm.selectedSharedReport.reportObject;
            if (_.startsWith(vm.selectedSharedReport.reportObject, "<")) {
                /* jshint -W117 */
                reportText = fmCovertXmlReport(vm.selectedSharedReport.reportObject);
                /* jshint +W117 */
            }
            var jsonReport = JSON.parse(reportText);
            jsonReport.dataSource.filename = dataUrl;
            jsonReport.dataSource = assureDataSourceType(jsonReport.dataSource);
            jsonReport.localization = '';

            pivot.setReport(jsonReport);
            pivot.closeFieldsList();

        } catch (error) {
            vm.isLoadingReport = false;
            pivot.clear();
            pivot.refresh();
            ToasterService.showError('"' + report.name + '": ' + error.message, "Rapporter");
        }
    }

    function assureDataSourceType(dataSource) {
        if (dataSource.type && dataSource.type.length > 0) {
            dataSource.dataSourceType = dataSource.type;
        } else if (dataSource.dataSourceType && dataSource.dataSourceType.length > 0) {
            dataSource.type = dataSource.dataSourceType;
        }

        return dataSource;
    }

    function saveReport() {

        var report = vm.selectedReport;
        var dataSource = vm.selectedDataSource;
        report.dataSourceId = dataSource.id;

        var reportObj = pivot.getReport();
        reportObj.dataSource.filename = "";
        reportObj.dataSource = assureDataSourceType(reportObj.dataSource);
        report.reportObject = JSON.stringify(reportObj);

        AnalysisApiService.saveReport(report).then(function (e) {
            ToasterService.showSuccess('"' + report.name + '" sparades.', "Rapporter");
        });
    }

    function saveNewUserReport() {
        var newReport = angular.copy(vm.selectedUserReport);
        vm.newReportName = $scope.cbSaveUserReport._tbx.value;
        var report = _.find(vm.userReports, { name: vm.newReportName });
        newReport.id = report === undefined ? -1 : report.id;

        if (vm.showSharedReportList) {
            newReport.name = vm.newReportName;
            newReport.description = vm.selectedSharedReport.description;
            newReport.dataSourceId = vm.selectedSharedReport.dataSourceId;
            newReport.reportTemplate = { id: vm.selectedSharedReport.reportTemplate.id };
        } else {
            newReport.name = vm.newReportName;
            newReport.description = vm.selectedReport.description;
            newReport.dataSourceId = vm.selectedReport.dataSourceId;
            newReport.reportTemplate = { id: vm.selectedReport.id };
        }

        var reportObj = pivot.getReport();
        reportObj.dataSource.filename = "";
        reportObj.dataSource = assureDataSourceType(reportObj.dataSource);
        newReport.reportObject = JSON.stringify(reportObj);

        AnalysisApiService.saveUserReport(newReport).then(function () {
            loadUserReports();
            ToasterService.showSuccess('"' + newReport.name + '" sparades.', "Rapporter");
        });

    }

    function canSaveUserReport() {
        var cb = $scope.cbSaveUserReport;
        var canSave = cb._tbx.value.length > 1 && !vm.isLoadingReport;
        if (vm.showSharedReportList && vm.selectedSharedReport.id === -1) {
            return false;
        }

        return canSave;
    }

    function deleteUserReport() {
        var report = angular.copy(vm.selectedUserReport);
        AnalysisApiService.deleteUserReport(report).then(function () {
            loadUserReports();
            ToasterService.showSuccess('"' + report.name + '" togs bort.', "Rapporter");
        });
    }


    function getUserReports($select) {
        return vm.userReports;
    }

    function editUserReport() {
        var report = angular.copy(vm.selectedUserReport);
        if (report.id === -1) {
            return;
        }

        var reportObj = pivot.getReport();
        reportObj.dataSource.filename = "";
        reportObj.dataSource = assureDataSourceType(reportObj.dataSource);
        report.reportObject = JSON.stringify(reportObj);

        AnalysisApiService.saveUserReport(report).then(function () {
            loadUserReports();
            ToasterService.showSuccess('"' + report.name + '" sparades.', "Rapporter");
        });
    }


    function cancelEditUserReport() {
        var report = _.find(vm.userReports, { id: vm.selectedUserReport.id });
        vm.selectedUserReport = report === undefined ? { id: -1, description: "" } : angular.copy(report);
    }

    function editFormSelectedReportChanged(e) {
        if (vm.initUserReports || e.isDroppedDown) {
            return;
        }
        var value = e.selectedValue;
        var report = _.find(vm.userReports, { id: value });
        vm.selectedUserReport = report === undefined ? { id: -1, description: "" } : angular.copy(report);
        loadUserReport(vm.selectedUserReport.id);
    }

    function selectedSharedReportChanged(e) {
        if (vm.initSharedReports || e.isDroppedDown) {
            return;
        }
        var value = e.selectedValue;
        var report = _.find(vm.sharedReports, { id: value });
        vm.selectedSharedReport = report === undefined ? { id: -1, description: "" } : angular.copy(report);
        loadSharedReport(vm.selectedSharedReport.id);
    }


    function formatDate(date, formatStr) {
        if (date === undefined) {
            return '';
        }
        return moment(date).format(formatStr);
    }

    function comboBoxInitialized(cb) {

        vm.reportComboBox = cb;
    }

    function expandRows(expand) {
        if (expand) {

            var firstLevel = pivot.getRows()[0];
            if (firstLevel !== undefined) {
                pivot.expandData(firstLevel.uniqueName);
            }
        } else {
            pivot.collapseAllData();
        }
    }

    function collapseRows() {
        pivot.collapseAllData();
    }

    function cbSelectLevelChanged(e) {
        if (!e || !e.selectedValue) {
            return;
        }
        pivot.expandData(e.selectedValue);
    }

    function removeMeasures() {
        var measures = pivot.getAllMeasures();
        _.forEach(measures, function (m) { pivot.removeCalculatedMeasure(m.uniqueName); });
    }
    function createPivot() {

        var pivotObj = $("#pivotContainer").flexmonster({
            componentFolder: '/assets/modules/flexmonster/',
            licenseKey: ENV.FLEXMONSTER_KEY,
            width: '100%',
            height: 700,
            toolbar: true,
            global: {
                localization: localization
            }
        });

        pivotObj.on("update", onPivotUpdate);
        pivotObj.on('dataerror', onPivotError);

        return pivotObj;
    }

    function onPivotError(e) {
        console.log('Error with data!' + e.error);
    }

    function onPivotUpdate() {
        vm.reportLevels = pivot.getRows();
        vm.isLoadingReport = false;
    }
    function convertAllReports() {
        _.forEach(vm.reports, function (report) {
            if (_.startsWith(report.reportObject, "<")) {
                /* jshint -W117 */
                var reportString = fmCovertXmlReport(report.reportObject);
                /* jshint +W117 */
                report.reportObject = reportString;
                AnalysisApiService.saveReport(report);
            }
        });
        AnalysisApiService.getUserReportsToConvert().then(function (userReports) {
            _.forEach(userReports, function (report) {
                if (_.startsWith(report.reportObject, "<")) {
                    /* jshint -W117 */
                    var reportString = fmCovertXmlReport(report.reportObject);
                    /* jshint +W117 */
                    report.reportObject = reportString;
                    AnalysisApiService.saveConvertedUserReport(report);
                }
            });
        });
    }
}



angular.module('analysis.reports', [])
    .config(stateConfig)
    .controller('AnalysisReportsController', AnalysisReportsController);
